import TransparentImage, { TransparentImageProps } from "./TransparentImage";

export { TransparentImage, TransparentImageProps };

export default TransparentImage;
